import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const slides = [
  {
    id: 1,
    title: "Ship AI-powered software you can trust",
    description: "Applications, Data/AI systems, and the platforms that keep them fast and safe.",
    image: "/images/hero1.jpg",
    buttonText: "Get Started"
  },
  {
    id: 2,
    title: "Senior pods, production outcomes",
    description: "Lean cross-functional squads to help you ship early, measure impact and close the feedback loop.",
    image: "/images/hero2.jpg",
    buttonText: "Talk to an Engineer"
  },
  {
    id: 3,
    title: "Platform Engineering + Security",
    description: "We build internal platforms that make the right way the easy way",
    image: "/images/hero3.jpg",
    buttonText: "Explore"
  }
];

const HeroSlider: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative overflow-hidden h-screen">
      <AnimatePresence>
        <motion.div
          key={currentSlide}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 3, ease: "easeInOut" }}
          className="absolute inset-0"
        >
          <div 
            className="w-full h-full bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${slides[currentSlide].image})` }}
          >
            <div className="absolute inset-0 bg-black/40"></div>
            
            <div className="relative z-10 flex items-center justify-center h-full text-center text-white">
              <motion.div
                key={`content-${currentSlide}`}
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -50, opacity: 0 }}
                transition={{ duration: 3.0, ease: [0.645, 0.045, 0.355, 1] }}
                className="max-w-4xl px-4"
              >
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-medium mb-6 leading-tight">
                  {slides[currentSlide].title}
                </h1>
                
                <p className="text-xl md:text-2xl mb-8 text-white/90 max-w-2xl mx-auto">
                  {slides[currentSlide].description}
                </p>
                
                <a
                  href="#cta"
                  className="px-8 py-4 rounded-xl text-lg font-medium bg-custom-indigo-500 text-white inline-block transition-all hover:bg-custom-indigo-600 transform hover:scale-105"
                >
                  {slides[currentSlide].buttonText}
                </a>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Slide indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'bg-white' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;